var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "#7D899D",
    stroke: "#7D899D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4313 5.8562C12.7831 5.43049 12.7233 4.80017 12.2976 4.44832C11.8719 4.09647 11.2415 4.15634 10.8897 4.58204L6.939 9.36199L5.40019 8.09015C4.97449 7.7383 4.34417 7.79817 3.99232 8.22387C3.64047 8.64957 3.70034 9.2799 4.12604 9.63175L6.35947 11.4777C6.3825 11.5009 6.40687 11.5231 6.43258 11.5444C6.68546 11.7534 7.01056 11.8171 7.30658 11.7452C7.5111 11.6968 7.70211 11.5837 7.84632 11.4093C7.86473 11.387 7.88201 11.3642 7.89816 11.3408L12.4313 5.8562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOn);
export default __webpack_public_path__ + "static/media/checkedOn.04404fad81af7a379ac230f08c734c2e.svg";
export { ForwardRef as ReactComponent };